import React, { Fragment } from 'react';

import { Box } from '~/eds/src/components/Box/Box';
import { Divider } from '~/eds/src/components/Divider/Divider';
import { Section } from '~/eds/src/components/Section/Section';
import { SnippetPart } from '~/redux/api/methods/search';

import CollapsibleSnippets from '../CollapsibleSnippets/CollapsibleSnippets';

type Props = {
  title: string;
  snippets: SnippetPart[][];
  limit?: number;
};
function TextSnippets({ title = '', snippets = [], limit = 300 }: Props) {
  return (
    <Section title={title}>
      {snippets.map((parts, index) => {
        return (
          <Fragment key={index}>
            <Box>
              <CollapsibleSnippets snippets={parts} limit={limit} />
            </Box>
            {index < snippets.length - 1 ? <Divider /> : null}
          </Fragment>
        );
      })}
    </Section>
  );
}

export default TextSnippets;
